interface ClickToCopyOptions {
  text: string;
  onSuccess?: () => void;
  onError?: () => void;
}

export async function clickToCopy({
  text,
  onSuccess,
  onError,
}: ClickToCopyOptions) {
  if (!text) return;

  try {
    await navigator.clipboard.writeText(text);
    onSuccess?.();
  } catch {
    onError?.();
  }
}
